import useSEO from "../hooks/useSEO";
import PageHero from "../components/site/PageHero";
import { Link } from "react-router-dom";

export default function PolicyPage({
  slug,
  title,
  intro,
  sections,
}) {
  useSEO({
    title: `${title} | Fire Safety Systems`,
    description: `${title} for the Fire Safety Systems website. For enquiries please contact us on 01 835 1454 or service@fssl.ie.`,
    canonicalPath: `/${slug}`,
  });

  return (
    <>
      <PageHero
        eyebrow="Policies"
        title={title}
        subtitle={intro}
        ctaPrimary={{ to: "/contact", label: "Contact FSS" }}
      />
      <section className="fss-section bg-white">
        <div className="fss-container max-w-3xl">
          <div className="space-y-8 text-slate-700 leading-relaxed">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display text-xl font-semibold text-slate-900 mb-3">
                  {s.h}
                </h2>
                {s.p.map((para, j) => (
                  <p key={j} className="mb-3 text-sm md:text-base">
                    {para}
                  </p>
                ))}
              </div>
            ))}
          </div>
          <div className="mt-10 border-t border-slate-200 pt-8 text-sm text-slate-500">
            For any questions about this policy, please{" "}
            <Link to="/contact" className="text-green-700 font-semibold hover:underline">
              contact us
            </Link>
            .
          </div>
        </div>
      </section>
    </>
  );
}
